"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12 3c-2.2824.0158-4.56.8944-6.3015 2.6358-3.5147 3.5147-3.5147 9.2132 0 12.7279 3.5148 3.5148 9.2132 3.5148 12.728 0 3.5147-3.5147 3.5147-9.2132 0-12.7279l1.4142-1.4142H15.598v4.2427L17.0122 7.05c2.7337 2.7337 2.7337 7.1659 0 9.8995-2.7336 2.7337-7.1658 2.7337-9.8994 0-2.7337-2.7336-2.7337-7.1658 0-9.8995C8.4636 5.6991 10.2294 5.0158 12 5V3z"
  }), _react.default.createElement("path", {
    d: "M12.9974 11.5831V6.9973h-2v5.4142l3.7954 3.7953 1.4142-1.4142-3.2096-3.2095z"
  })];
};

exports.default = _default;